module.exports = __webpack_public_path__ + "static/media/global-shoppng-33.a1eb17d9.png";